"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InfoLabel_1 = require("./InfoLabel");
Object.defineProperty(exports, "InfoLabel", { enumerable: true, get: function () { return InfoLabel_1.InfoLabel; } });
//# sourceMappingURL=index.js.map